import React from "react";
import PropTypes from "prop-types";
import SearchableSelect from "js/components/SearchableSelect";

const DAYS_MAP = [
	["mon", "Monday"],
	["tue", "Tuesday"],
	["wed", "Wednesday"],
	["thur", "Thursday"],
	["fri", "Friday"],
	["sat", "Saturday"],
	["sun", "Sunday"],
];

const ClassroomSessionSchedulerDaySelector = ({ onChange, value }) => {
	const handleChange = ({ value: newValue }) => {
		onChange(newValue);
	};
	return (
		<SearchableSelect
			valueDataMap={DAYS_MAP}
			onChange={handleChange}
			className="ClassroomSessionScheduler_select"
			placeholder="Select Day"
			value={value}
		/>
	);
};

ClassroomSessionSchedulerDaySelector.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.string,
};

export default ClassroomSessionSchedulerDaySelector;
